import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  password: Yup.string().required('msg_password_required'),
  confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'msg_passwords_must_match'),
});
